import { render, staticRenderFns } from "./LibraryBooksManager.vue?vue&type=template&id=48dc106e&"
import script from "./LibraryBooksManager.vue?vue&type=script&lang=js&"
export * from "./LibraryBooksManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports